"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LocalsContext = _interopRequireDefault(require("../../context/LocalsContext"));
var _UiContext = _interopRequireDefault(require("../../context/UiContext"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Locals = _ref => {
  var _useContext;
  let {
    children,
    url
  } = _ref;
  const [locals, setLocals] = (0, _react.useState)({});
  const setUi = (_useContext = (0, _react.useContext)(_UiContext.default)) === null || _useContext === void 0 ? void 0 : _useContext[1];
  (0, _react.useEffect)(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    const fetchLocals = async () => {
      if (!url) return;
      try {
        let result = await fetch(url, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          signal
        });
        if (result.status === 404) {
          return;
        }
        const data = await result.json();
        setLocals(data);
      } catch (error) {}
    };
    fetchLocals();
    return () => {
      controller.abort();
    };
  }, [url]);
  (0, _react.useEffect)(() => {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes") {
          if (mutation.attributeName === "showlocals") {
            if (mutation.target.getAttribute("showlocals") === null) {
              // hide
              setUi(prevUi => ({
                ...prevUi,
                _showLocals: false
              }));
              return;
            }

            // show
            setUi(prevUi => ({
              ...prevUi,
              _showLocals: true
            }));
            return;
          }
        }
      });
    });
    observer.observe(document.querySelector("body"), {
      attributes: true
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_LocalsContext.default.Provider, {
    value: [locals, setLocals]
  }, children);
};
Locals.propTypes = {
  url: _propTypes.default.string
};
var _default = exports.default = Locals;